import React from 'react';

/**
 * Last-resort screen for render errors: without it React unmounts the whole app
 * and the user is left with a blank page and nothing to report.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Render error:', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F6F8] p-4">
        <div className="max-w-md w-full bg-white border border-[#E2E8F0] rounded-sm p-6 space-y-4">
          <h1 className="font-outfit text-xl font-semibold text-[#0A0F1A]">Si è verificato un errore</h1>
          <p className="text-base text-[#4A5568]">
            La pagina non è riuscita a mostrare questi dati. I tuoi preventivi salvati non sono stati toccati.
          </p>
          <p className="text-xs text-[#4A5568] font-mono bg-[#F4F6F8] p-2 rounded-sm break-words">
            {String(error?.message || error)}
          </p>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="flex-1 h-11 bg-[#0033A0] text-white rounded-sm font-medium"
            >
              Ricarica la pagina
            </button>
            <button
              type="button"
              onClick={() => { window.location.href = '/dashboard'; }}
              className="flex-1 h-11 border border-[#0033A0] text-[#0033A0] rounded-sm font-medium"
            >
              Torna alla home
            </button>
          </div>
        </div>
      </div>
    );
  }
}
